import { ReplyForm } from "@/components/Forms/ReplyForm";
import { reviewsStore } from "@/stores/ReviewsStore";
import { CloseOutlined } from "@ant-design/icons";
import { IconMessageCircle2 } from "@tabler/icons-react";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import styles from "./Reply.module.css";

export const Reply = observer(() => {
  return (
    <div
      className="
        flex 
        flex-col 
        gap-[3px]
        
        "
    >
      {reviewsStore.parent_id !== null && (
        <div className="flex z-2 flex-row gap-2 items-center justify-between [background:var(--global-wine-color)] !p-2 rounded border-1 border-[rgba(0,0,0,0.55)]">
          <section className="flex flex-row gap-1 items-center">
            <span className="text-[10px] [color:var(--global-default-color-text)]">ответить на</span>
            <IconMessageCircle2 className="w-4 h-4 [stroke:var(--global-default-color-text)]" />
            <span className="text-[10px] [color:var(--global-default-color-text)]">
              [{reviewsStore.visitorName}]
            </span>
          </section>
          <CloseOutlined
            className={clsx("w-3 h-3 cursor-pointer", styles.close)}
            onClick={() => {
              if (reviewsStore.entity_type === "reply") {
                reviewsStore.modal.isHide();
                return;
              }
              reviewsStore.clearReply();
            }}
          />
        </div>
      )}

      {reviewsStore.parent_id !== null && <ReplyForm />}
    </div>
  );
});
